import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { ExutoireDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-exutoire',
  templateUrl: './exutoire.component.html',
  styleUrls: ['./exutoire.component.css']
})
export class ExutoireComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.exutoires$) exutoires$: Observable<ExutoireDto[]>;

  private _exutoireId: number = null;
  Exutoires: ExutoireDto[] = [];

  @Input()
  get exutoireId() {
    return this._exutoireId;
  }
  set exutoireId(val) {
    this._exutoireId = val;
    this.getExutoireInComponent();
  }

  ExutoireInComponent: string;

  e: Subscription;

  constructor() { }

  ngOnInit() {
    this.e = this.exutoires$.subscribe(res => {
      if (res != null) {
        this.Exutoires = res;
        this.getExutoireInComponent();
      }
    });
  }

  getExutoireInComponent() {
    let exutoire = this.Exutoires.find(p => p.Id == this.exutoireId);
    this.ExutoireInComponent = (exutoire) ? exutoire.Identifiant : null;
  }

  ngOnDestroy() {
    this.e?.unsubscribe();
  }

}
